import { CreatorBrand } from 'constants/brands';
import React, { useCallback } from 'react';
import { Modal, Button, Text, Group } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';

export const ConfirmLoadSessionModal: React.FC = () => {
    const {
        state: creatorState,
        closeLoadSessionModal,
        dispatchLoadSession,
        openCreator,
    } = useCreatorContext();

    const handleOnClick = useCallback(() => {
        dispatchLoadSession({ withAutoplay: true });
        openCreator();
    }, [dispatchLoadSession, openCreator]);

    return (
        <Modal
            isOpen={creatorState.isLoadSessionModalOpen}
            onClose={closeLoadSessionModal}
        >
            <Modal.Content>
                <Modal.Section>
                    <Group direction="vertical" gap="xs">
                        <Group.Item>
                            <Text textStyle="title-sm" fontWeight="bold">
                                <Trans>Open in {CreatorBrand}?</Trans>
                            </Text>
                        </Group.Item>
                        <Group.Item>
                            <Text textStyle="body" color="text.medium">
                                <Trans>
                                    You're about to add samples to{' '}
                                    {CreatorBrand}. All sounds currently in{' '}
                                    {CreatorBrand} will be removed. Are you
                                    sure?
                                </Trans>
                            </Text>
                        </Group.Item>
                    </Group>
                    <Group
                        mt="xl"
                        marginLeft="auto"
                        justifyContent="right"
                        alignItems="center"
                        width={{ base: '100%', md: '50%' }}
                    >
                        <Group.Item width="100%">
                            <Button
                                kind="minimal"
                                variant="secondary"
                                onClick={closeLoadSessionModal}
                                isFull
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        </Group.Item>
                        <Group.Item width="100%" marginLeft="md">
                            <Button
                                variant="primary"
                                onClick={handleOnClick}
                                isFull
                            >
                                <Trans>Continue</Trans>
                            </Button>
                        </Group.Item>
                    </Group>
                </Modal.Section>
            </Modal.Content>
        </Modal>
    );
};

export default ConfirmLoadSessionModal;
